import HeaderFooterLayout from 'layouts/HeaderFooterLayoutNew';
import React from 'react';
import MembershipForms from 'components/HomePageNew/MembershipForms';

const MembershipFormsPage = ({ ...props }) => {
  return (
    <div>
      <HeaderFooterLayout>
        <MembershipForms {...props} />
      </HeaderFooterLayout>
    </div>
  );
};

export default MembershipFormsPage;
